import React, { useEffect } from "react";
import {
  $InternalStudentCourseState,
  $InternalStudentCourse,
  fetchInternalStudentCourse,
} from "@store/internal-study/students-store";
import { useUnit } from "effector-react";
import { useParams, useLocation } from "react-router-dom";
import { ErrorIndicator, Loader } from "@ui/indicators";
import Lessons from "@components/students/lessons";
import { setTitle } from "@store/title-store";

export const StudentsCourse: React.FC = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const { pathname } = useLocation();

  const { isLoading, error, isFetched } = useUnit($InternalStudentCourseState);
  const course = useUnit($InternalStudentCourse);

  useEffect(() => {
    if (!isFetched) {
      fetchInternalStudentCourse(+courseId!);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (course && course.course_info) {
      setTitle([
        {
          title: "Курсы",
          href: "/",
        },
        {
          title: course.course_info.title,
          href: pathname,
        },
      ]);
    }
  }, [course, pathname]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <ErrorIndicator />
      ) : (
        <Lessons
          courseId={course.id}
          stage={course.stage}
          items={course.course_info.lessons!}
        />
      )}
    </>
  );
};
